import _chunk from "lodash/chunk";
import cx from "classnames";
import React, { useEffect, useState, useRef, Suspense } from "react";
import { fetchGetCarListData, fetchGetBrandsInfoMsg, fetchGetBrandsListData } from "@Services/api";
import { ICarListData } from "@Components/newModels/CarList/index";
import styles from "./findCar.module.less";
import withLayout from "../../../src/layouts/withLayout";
import AdIframeImage from "@Components/ad/AdFrame_v2";
import { Skeleton } from "antd";
import FilterContent from "@Components/newModels/FilterContent/ModelsFilter"
import CarHome from "@Components/newModels/CarHome/index"
import CarBrands from "@Components/newModels/CarBrands/List"
import CarList from "@Components/newModels/CarList/index"


const FindCar = () => {
  const [browsingListoryList, setBrowsingListoryList] = useState<ICarListData[]>([]);
  const [salesValue, setSalesValue] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [hasCollect, setHasCollect] = useState(false);
  const [listData, setListData] = useState<ICarListData[]>([]);
  const [brandsListData, setBrandsListData] = useState({
    list: [],
    index: [],
  });
  const [isFixed, setFixed] = useState(false);
  const [totalObj, setTotalObj] = useState({
    total: 0,
    kindNum: 0,
    modelNum: "",
    isEv: false,
  });

  const [brandsInfoMsg, setBrandsInfoMsg] = useState({
    brandLogo: "",
    content: "",
    name: "",
    code: "",
  });

  const filterParams = useRef<any>({}); // 厂牌、价格、级距、等
  const carListParams = useRef<any>({}); // 排序、優惠車款、等
  const themeColorStyle = useRef<any>({});

  const getCarList = async (param = {}) => {
    setLoading(true);
    setListData([]);
    try {
      const params = {
        sort: "views-desc",
        limit: 20,
        page: 1,
        p: "",
        saleStop: salesValue,
        ...param,
        ...carListParams.current,
        ...filterParams.current,
        b: window.query_brand_id,
      };

      window.SEARCH_TYPE === "ev" && (params.p = "5");

      const res = await fetchGetCarListData(params);

      localStorage.setItem("nc_brand", window.BRAND_INFO_DESCRIPTION?.brandUrlName || "");
      localStorage.setItem("nc_kind", "");
      setHasCollect(true);
      if (res && res.status === 12000) {
        addRTBHEvents({
          b: params.b,
          k: res.data.list?.map((item) => item.kindId).slice(0, Math.min(5, res.data.list?.length)),
        });
        setListData([...res.data.list]);
        setTotalObj({
          total: res.data.total,
          kindNum: res.data.kindNum,
          modelNum: res.data.modelNum,
          isEv: res.data.isEv,
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const addRTBHEvents = ({ b, k }) => {
    if (!window?.rtbhEvents) {
      window.rtbhEvents = [];
    }
    if (b) {
      (window.rtbhEvents = window.rtbhEvents || []).push(
        {
          eventType: "category",
          categoryId: b,
        },
        {
          eventType: "uid",
          id: window?.loginMid || "unknown",
        },
      );

      return;
    }
    if (k) {
      (window.rtbhEvents = window.rtbhEvents || []).push(
        {
          eventType: "listing",
          offerIds: k,
        },
        {
          eventType: "uid",
          id: window?.loginMid || "unknown",
        },
      );
    }
  };

  const getBrandsList = async () => {
    try {
      const res = await fetchGetBrandsListData({
        type: window.SEARCH_TYPE || "default",
      });
      if (res && res.status === 12000) {
        setBrandsListData(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getBrandsInfoMsg = async () => {
    try {
      const res = await fetchGetBrandsInfoMsg({
        brandId: window.BRAND_INFO_DESCRIPTION ? window.BRAND_INFO_DESCRIPTION.brandId : "",
      });
      if (res && res.status === 12000) {
        setBrandsInfoMsg({
          ...res.data,
          code: "https://p3.8891.com.tw/nc/newcar/article/2021/01/19/1611044094465258.jpg",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  /**
   * 组件返回筛选数据
   */
  const handleChangeList = async (params) => {
    filterParams.current = params;
    window.PAGE_NAME !== "modelIndex" &&
      getCarList({
        page: 1,
      });
  };

  /**
   * 切换主题色
   */
  const getThemeColorStyle = async (): Promise<any> => {
    themeColorStyle.current = {
      color: "#fff",
      background: window.SEARCH_TYPE ? (window.SEARCH_TYPE === "default" ? "#3264ff" : "#1DBF76") : "#3264ff",
    };
  };

  const handleScroll = () => {
    if (window.scrollY > 135 && window.innerHeight + window.scrollY <= document.body.scrollHeight - 160) {
      setFixed(true);
      return;
    }
    setFixed(false);
  };

  useEffect(() => {
    const browsingListoryList = localStorage.getItem("findCarBrowsingListoryList");
    if (browsingListoryList) {
      setBrowsingListoryList([...JSON.parse(browsingListoryList)]);
    }
    getCarList();
    getBrandsList();
    getBrandsInfoMsg();
    getThemeColorStyle();

    (window.rtbhEvents = window.rtbhEvents || []).push(
      {
        eventType: "home",
      },
      {
        eventType: "uid",
        id: window?.loginMid || "unknown",
      },
    );

    window.addEventListener("scroll", handleScroll as any);
    return () => window.removeEventListener("scroll", handleScroll as any);
  }, []);

  return (
    <section id='findCar' className={styles["find-car"]} style={{ minHeight: "878px" }}>
      <div className={styles["main-container"]} style={{ minHeight: "858px" }}>
        <div className={styles["left-box"]}>
          <div
            className={cx(styles["fixed-box"], {
              [styles["fixed"]]: isFixed,
            })}
          >
            {Array.isArray(brandsListData.list) && !!brandsListData.list.length ? (
              <CarBrands brandsListItem={brandsListData} />
            ) : (
              <Skeleton active style={{ height: 858 }} />
            )}
          </div>
        </div>

        <div className={styles["center-container"]}>
          <div className={styles["records"]}>
            <div className={styles["records-box"]}>
              {browsingListoryList.length > 0 && (
                <>
                  <p className={styles["records-title"]}>瀏覽記錄</p>
                  <div className={styles["records-list"]}>
                    {browsingListoryList.map((item: any, index: number) => (
                      <React.Fragment key={item.kindId}>
                        {index < 3 && (
                          <div
                            className={styles["list-item"]}
                            style={{
                              background: themeColorStyle.current.background,
                              opacity: 0.6,
                            }}
                          >
                            <a
                              key={item.kindId}
                              href={item.summaryLink}
                              target='_blank'
                            >{`${item.brandName} ${item.kindName}`}</a>
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>

          <div className={styles["filter-wrapper"]} style={{ minHeight: "320px" }}>
            {Array.isArray(brandsListData.list) && !!brandsListData.list.length ? (
              <FilterContent
                themeColorStyle={themeColorStyle.current}
                brandsListItem={brandsListData.list}
                onChange={(params) => handleChangeList(params)}
              />
            ) : (
              <Skeleton active style={{ height: 320 }} />
            )}
          </div>

          {hasCollect ? (
            <div className='relative'>
              <AdIframeImage
                slot={"/173427088/newcar-pc-model-top"}
                size={[["fluid"], [930, 180]]}
                width={930}
                height={180}
                styles={{ width: 930, height: 180, marginBottom: 20 }}
              />
            </div>
          ) : (
            <Skeleton active style={{ height: 180 }} />
          )}

          <CarHome />

          <div className={styles["filter-main"]}>
            {loading && <Skeleton style={{ height: 250 }} />}
            {["modelKind", "modelSearch", "modelEVSearch"].includes(window.PAGE_NAME) && (
              <CarList
                totalObj={totalObj}
                dataSource={listData}
                brandsInfoMsg={brandsInfoMsg}
                salesValue={salesValue}
                setSalesValue={setSalesValue}
                loading={loading}
                onChange={(params) => {
                  carListParams.current = params
                  getCarList()
                }}
              />
            )}

            {/* 大屏廣告 */}
            {hasCollect ? (
              <div className='relative'>
                <AdIframeImage
                  slot={"/173427088/newcar-pc-model-bottom"}
                  size={[["fluid"], [930, 180]]}
                  width={930}
                  height={180}
                  styles={{ width: 930, height: 180, marginBottom: 20 }}
                />
              </div>
            ) : (
              <Skeleton active style={{ height: 180 }} />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

withLayout({
  cmp: <FindCar />,
  params: {
    needRTBH: true,
    AdTopBanner: true,
    nav: "DefaultFixedNav",
    footer: "Footer",
  },
});
